import React, { Suspense } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import Loader from '@components/common/Loader';

const HomePage = React.lazy(() => import('@pages/HomePage'));
const EventPageHandlerPage = React.lazy(
  () => import('@pages/EventPageHandlerPage')
);
const AccessDeniedPage = React.lazy(() => import('@pages/AccessDeniedPage'));
const OrganizationOverlordDetailsPage = React.lazy(
  () => import('@pages/OrganizationDetailsPage')
);

import { ROUTE_PATHS } from './RoutePaths';
import { useAuth } from '@contexts/AuthContext';
import CrawlQueuePage from '@pages/CrawlQueuePage';

const DraftProductionsPage = React.lazy(
  () => import('@pages/DraftProductionsPage')
);

const AppRouter = () => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <Loader />;
  }

  return (
    <Router>
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route
            path={ROUTE_PATHS.ACCESS_DENIED}
            element={<AccessDeniedPage />}
          />
          <Route
            path={ROUTE_PATHS.HOME}
            element={
              isAuthenticated ? (
                <HomePage />
              ) : (
                <Navigate to={ROUTE_PATHS.ACCESS_DENIED} />
              )
            }
          />
          <Route
            path={ROUTE_PATHS.EVENT_PAGE_HANDLER}
            element={<EventPageHandlerPage />}
          />
          <Route path={ROUTE_PATHS.CRAWL_QUEUE} element={<CrawlQueuePage />} />
          <Route
            path={ROUTE_PATHS.DRAFT_PRODUCTIONS}
            element={
              isAuthenticated ? (
                <DraftProductionsPage />
              ) : (
                <Navigate to={ROUTE_PATHS.ACCESS_DENIED} />
              )
            }
          />
          <Route
            path={ROUTE_PATHS.ORGANIZATION_DETAILS}
            element={<OrganizationOverlordDetailsPage />}
          />
          <Route
            path={ROUTE_PATHS.CREATE_ORGANIZATION}
            element={<OrganizationOverlordDetailsPage />}
          />
          <Route path={'*'} element={<Navigate to={ROUTE_PATHS.HOME} />} />
        </Routes>
      </Suspense>
    </Router>
  );
};

export default AppRouter;
